import { call, all } from 'redux-saga/effects';
import {watchGetDataLayout, watchSetDataLayout,watchGetDataNoti,watchGetDataLogOut, watchUpdateDataNotification} from "./layoutSaga";
//IndexImportHygen

export default function* rootLayoutSaga() {
  yield all([
    call(watchGetDataLayout),
    call(watchSetDataLayout),
    call(watchGetDataNoti),
    call(watchGetDataLogOut),
    call(watchUpdateDataNotification),
    //IndexUsingHygen
    ])
}